import { BaseResAPI } from "@/@core/entity/res-api.entity";
import { Stock } from "@/@core/entity/stock.entity";
import api from "@/api/axios";

export interface GetStockDTO {
  page: number;
  limit: number;
  serial_number: string;
  type:
    | 1 // stock-quantity
    | 2; // stock-transfer;
}

export type GetStockResp = BaseResAPI<Stock[]>;

/**
 *
 * @param params
 *  type:
 *      1 for "stock-quantity"
 *      2 for "stock-transfer"
 * @returns
 */
const getStockInteractor = (params: GetStockDTO): Promise<GetStockResp> => {
  const { page, limit, type, serial_number } = params;
  const path = `/admin/stock`;
  let pathParam = "?";
  if (page) pathParam += `&page=${page}`;
  if (limit) pathParam += `&limit=${limit}`;
  if (type) pathParam += `&type=${type}`;
  if (serial_number) pathParam += `&serial_number=${serial_number}`;
  return api.get(pathParam === "?" ? path : path + pathParam);
};

export default getStockInteractor;
